(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apple-bento-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    const sections = document.querySelectorAll('.apple-bento');
    
    sections.forEach(section => {
      // Header fade
      const header = section.querySelector('.apple-bento__header');
      if (header) {
        gsap.fromTo(header, {
          y: 40,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: header,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        });
      }

      // Bento Items Stagger
      const items = section.querySelectorAll('.gsap-bento-reveal');
      if (items.length > 0) {
        gsap.fromTo(items, {
          y: 60,
          opacity: 0,
          scale: 0.95
        }, {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.8,
          stagger: 0.1,
          ease: "back.out(1.2)",
          scrollTrigger: {
            trigger: section.querySelector('.apple-bento__grid'),
            start: "top 80%",
            toggleActions: "play none none none"
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apple-feature-split"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    const sections = document.querySelectorAll('.apple-feature-split');
    
    sections.forEach(section => {
      const media = section.querySelector('.gsap-split-media');
      const textContent = section.querySelector('.gsap-split-text');
      const parallaxImage = section.querySelector('.gsap-parallax-image');

      // Media fade/slide in
      if (media) {
        gsap.fromTo(media, {
          y: 60,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: 1.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        });
      }

      // Parallax effect on the image itself
      if (parallaxImage) {
         gsap.to(parallaxImage, {
           yPercent: 15,
           ease: "none",
           scrollTrigger: {
             trigger: section,
             start: "top bottom",
             end: "bottom top",
             scrub: true
           }
         });
      }

      // Text fade in
      if (textContent) {
        gsap.fromTo(textContent.children, {
          y: 30,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.15,
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 75%",
            toggleActions: "play none none reverse"
          }
        });
      }

      // Accordion interactivity
      const accordions = section.querySelectorAll('.apple-feature-split__accordion');
      accordions.forEach(acc => {
        const btn = acc.querySelector('.apple-feature-split__accordion-btn');
        const wrapper = acc.querySelector('.apple-feature-split__accordion-content-wrapper');
        if(btn && wrapper) {
          btn.addEventListener('click', () => {
             const isOpen = wrapper.classList.contains('is-open');
             if(isOpen) {
               wrapper.classList.remove('is-open');
               btn.classList.remove('is-open');
               btn.setAttribute('aria-expanded', 'false');
             } else {
               wrapper.classList.add('is-open');
               btn.classList.add('is-open');
               btn.setAttribute('aria-expanded', 'true');
             }
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apple-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Wait for GSAP
    if (typeof gsap === 'undefined') return;

    const sections = document.querySelectorAll('.apple-hero');
    
    sections.forEach(section => {
      const elements = section.querySelectorAll('.gsap-fade-up');
      
      if(elements.length > 0) {
        gsap.fromTo(elements, {
          y: 50,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: 1.2,
          stagger: 0.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            toggleActions: "play none none none"
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apple-marquee"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof gsap === 'undefined') return;

    const tracks = document.querySelectorAll('.gsap-marquee-track');
    
    tracks.forEach(track => {
      // Calculate how far to move. We duplicate content 4 times, so we need to move exactly 1 "set" 
      // which is width / 4, but since flex doesn't wrap, we animate exactly 25% to loop seamlessly.
      // Easiest seamless loop is using a modifier or just a standard xPercent loop based on the clone count
      
      let tween = gsap.to(track, {
        xPercent: -50, // Move 50% left (which covers 2 of the 4 clones)
        repeat: -1,
        duration: 25,
        ease: "none"
      });
      
      // Pause on hover
      track.addEventListener('mouseenter', () => tween.pause());
      track.addEventListener('mouseleave', () => tween.play());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apple-quote"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    const quotes = document.querySelectorAll('.gsap-quote');
    
    quotes.forEach(quote => {
      // Split text into words for animation.
      // Since GSAP SplitText is a premium plugin, we use a simple vanilla JS split here.
      const text = quote.textContent.trim();
      const words = text.split(' ');
      quote.innerHTML = ''; // Clear original text
      
      words.forEach(word => {
        const span = document.createElement('span');
        span.textContent = word + ' ';
        span.style.display = 'inline-block';
        span.style.opacity = '0.1'; // Start very dim
        // A little subtle push down
        span.style.transform = 'translateY(10px)'; 
        quote.appendChild(span);
      });

      // Animate words on scroll
      const wordSpans = quote.querySelectorAll('span');
      
      gsap.to(wordSpans, {
        opacity: 1,
        y: 0,
        stagger: 0.1, // Delay between each word
        duration: 0.5,
        ease: "power1.out",
        scrollTrigger: {
          trigger: quote,
          start: "top 85%", // Start when top of quote is at 85% of viewport
          end: "bottom 50%", // End when bottom of quote is at center of viewport
          scrub: 1 // Smooth scrubbing for Apple-like control
        }
      });
    });

    // Animate Author
    const authors = document.querySelectorAll('.gsap-quote-author');
    authors.forEach(author => {
      gsap.fromTo(author, {
        opacity: 0,
        y: 20
      }, {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: 0.5,
        scrollTrigger: {
          trigger: author,
          start: "top 90%",
          toggleActions: "play none none reverse"
        }
      });
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apple-scroll-indicator"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    const sections = document.querySelectorAll('.apple-scroll-indicator');
    
    sections.forEach(section => {
      // Fade up the text
      const textElements = section.querySelectorAll('.gsap-fade-up');
      if(textElements.length > 0) {
        gsap.fromTo(textElements, {
          y: 30,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        });
      }

      // Animate the SVG paths
      const paths = section.querySelectorAll('.apple-scroll-indicator__path');
      paths.forEach(path => {
        // Get total length of path for draw-on effect
        const length = path.getTotalLength ? path.getTotalLength() : 1000;
        
        // Simple fallback if it's a line/circle without length, we just fade/scale
        if(!path.getTotalLength) {
           gsap.from(path, {
            opacity: 0,
            scale: 0.8,
            duration: 1.5,
            scrollTrigger: {
              trigger: section,
              start: "top 70%",
              end: "bottom 40%",
              scrub: 1
            }
          });
          return;
        }

        // Draw SVG effect tied to scroll
        gsap.set(path, { strokeDasharray: length, strokeDashoffset: length });
        
        gsap.to(path, {
          strokeDashoffset: 0,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            end: "bottom 40%",
            scrub: 0.5 // Smooth scrubbing
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apple-sticky-scroll"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    // We only want the pin effect on desktop where there is room side-by-side
    let mm = gsap.matchMedia();

    mm.add("(min-width: 990px)", () => {
      const sections = document.querySelectorAll('.apple-sticky-scroll');
      
      sections.forEach(section => {
        const container = section.querySelector('.apple-sticky-scroll__container');
        const mediaSide = section.querySelector('.apple-sticky-scroll__media-side');
        
        // Pin the media side
        ScrollTrigger.create({
          trigger: container,
          start: "top top",
          end: "bottom bottom", 
          pin: mediaSide,
          pinSpacing: false // Do not add spacing, the text side continues to scroll natively
        });

        // Fade in/out text blocks as they hit the center
        const textBlocks = section.querySelectorAll('.gsap-sticky-text');
        textBlocks.forEach((block, index) => {
          gsap.fromTo(block, {
            opacity: 0.3,
            scale: 0.95
          }, {
            opacity: 1,
            scale: 1,
            duration: 0.5,
            scrollTrigger: {
              trigger: block,
              start: "top 60%",
              end: "bottom 40%",
              toggleActions: "play reverse play reverse",
              // Use scrub for a smoother fade, or keep toggleActions for distinct steps
              // scrub: true 
            }
          });
        });
      });
    });

    // Mobile fallback animations (just fade up)
    mm.add("(max-width: 989px)", () => {
      const textBlocks = document.querySelectorAll('.gsap-sticky-text');
      textBlocks.forEach(block => {
        gsap.from(block, {
          y: 40,
          opacity: 0,
          duration: 0.8,
          scrollTrigger: {
            trigger: block,
            start: "top 85%"
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apple-tabbed-specs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    
    // Tab Switching Logic
    const sections = document.querySelectorAll('.apple-tabbed-specs');
    
    sections.forEach(section => {
      const buttons = section.querySelectorAll('.apple-tabbed-specs__tab-button');
      const panels = section.querySelectorAll('.apple-tabbed-specs__panel');

      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const targetId = button.getAttribute('data-target');
          const targetPanel = document.getElementById(targetId);

          // Deactivate all tabs and hide all panels immediately
          buttons.forEach(btn => btn.classList.remove('is-active'));
          panels.forEach(panel => {
            panel.classList.remove('is-active');
            panel.style.display = 'none';
            panel.style.opacity = '0';
            if (typeof gsap !== 'undefined') {
              gsap.killTweensOf(panel);
            }
          });

          // Activate the clicked tab and show its panel
          button.classList.add('is-active');
          if (targetPanel) {
            targetPanel.classList.add('is-active');
            targetPanel.style.display = 'block';
            if (typeof gsap !== 'undefined') {
              gsap.fromTo(targetPanel,
                { opacity: 0, y: 10 },
                { opacity: 1, y: 0, duration: 1.2, ease: "power2.out" }
              );
            } else {
              targetPanel.style.opacity = '1';
            }
          }
        });
      });
      
      // Initial GSAP Fade Up when section enters viewport
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        const fadeElements = section.querySelectorAll('.gsap-fade-up');
        if (fadeElements.length > 0) {
          gsap.fromTo(fadeElements, {
            y: 40,
            opacity: 0
          }, {
            y: 0,
            opacity: 1,
            duration: 0.8,
            stagger: 0.1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none"
            }
          });
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-jersey"] && !Shopify.designMode) return;
  try {
    
  class JerseyProduct extends HTMLElement {
    #variants = [];
    #galleryObserver = null;

    connectedCallback() {
      const variantData = this.querySelector('[data-variant-data]');
      if (!variantData) return;

      try {
        this.#variants = JSON.parse(variantData.textContent);
      } catch (error) {
        console.error('Unable to load jersey variants', error);
        return;
      }

      this.addEventListener('change', this.#handleOptionChange);
      this.addEventListener('click', this.#handleGalleryClick);
      this.#observeGallery();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#handleOptionChange);
      this.removeEventListener('click', this.#handleGalleryClick);
      this.#galleryObserver?.disconnect();
    }

    #handleOptionChange = (event) => {
      if (!event.target.matches('[data-option-input]')) return;

      const selectedOptions = Array.from(this.querySelectorAll('[data-option-position]')).map((fieldset) => {
        const selected = fieldset.querySelector('[data-option-input]:checked');
        const selectedLabel = fieldset.querySelector('[data-selected-option]');
        if (selectedLabel && selected) selectedLabel.textContent = selected.value;
        return selected?.value;
      });

      const variant = this.#variants.find((item) =>
        item.options.every((option, index) => option === selectedOptions[index])
      );

      this.#updateVariant(variant);
    };

    #updateVariant(variant) {
      const variantId = this.querySelector('[data-variant-id]');
      const price = this.querySelector('[data-price]');
      const comparePrice = this.querySelector('[data-compare-price]');
      const status = this.querySelector('[data-variant-status]');
      const button = this.querySelector('[ref="addToCartButton"]');
      const buttonText = button?.querySelector('.add-to-cart-text__content span span');
      const quantity = this.querySelector('.jersey-quantity__input');
      const availableText = this.dataset.availableText || 'Available';
      const addToCartText = this.dataset.addToCartText || 'Add to cart';
      const soldOutText = this.dataset.soldOutText || 'Sold out';
      const unavailableText = this.dataset.unavailableText || 'Unavailable';

      if (!variant) {
        if (variantId) variantId.value = '';
        if (status) status.textContent = unavailableText;
        if (button) button.disabled = true;
        if (buttonText) buttonText.textContent = unavailableText;
        return;
      }

      if (variantId) variantId.value = variant.id;
      if (price) price.textContent = variant.price;
      if (comparePrice) {
        comparePrice.textContent = variant.comparePrice || '';
        comparePrice.classList.toggle('jersey-product__compare-price--hidden', !variant.comparePrice);
      }
      if (status) status.textContent = variant.available ? availableText : soldOutText;
      if (button) button.disabled = !variant.available;
      if (buttonText) buttonText.textContent = variant.available ? addToCartText : soldOutText;

      if (quantity) {
        quantity.min = variant.quantityMin || 1;
        quantity.step = variant.quantityStep || 1;
        if (variant.quantityMax) quantity.max = variant.quantityMax;
        else quantity.removeAttribute('max');
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (variant.featuredMediaId) this.#showMedia(variant.featuredMediaId);
    }

    #handleGalleryClick = (event) => {
      const dot = event.target.closest('[data-gallery-dot]');
      if (!dot) return;

      const items = this.querySelectorAll('[data-gallery-item]');
      const target = items[Number(dot.dataset.galleryDot)];
      target?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    };

    #showMedia(mediaId) {
      const target = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!target || window.matchMedia('(min-width: 990px)').matches) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    #observeGallery() {
      const gallery = this.querySelector('[data-gallery]');
      const items = this.querySelectorAll('[data-gallery-item]');
      if (!gallery || items.length < 2 || !('IntersectionObserver' in window)) return;

      this.#galleryObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const index = Array.from(items).indexOf(entry.target);
            for (const dot of this.querySelectorAll('[data-gallery-dot]')) {
              const isActive = Number(dot.dataset.galleryDot) === index;
              dot.classList.toggle('jersey-gallery-nav__button--active', isActive);
              dot.setAttribute('aria-current', isActive ? 'true' : 'false');
            }
          }
        },
        { root: gallery, threshold: 0.6 }
      );

      for (const item of items) this.#galleryObserver.observe(item);
    }
  }

  if (!customElements.get('jersey-product')) {
    customElements.define('jersey-product', JerseyProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-models"] && !Shopify.designMode) return;
  try {
    
  class MegaMenuModels {
    constructor() {
      this.wrapper = document.querySelector('.page-models-wrapper');
      if (!this.wrapper) return;
      
      this.modelTriggers = this.wrapper.querySelectorAll('[data-model-trigger]');
      
      this.focusTitle = this.wrapper.querySelector('#MegaMenuModels-FocusTitle');
      this.focusDesc = this.wrapper.querySelector('#MegaMenuModels-FocusDesc');
      this.focusUrl = this.wrapper.querySelector('#MegaMenuModels-FocusUrl');
      this.focusImage = this.wrapper.querySelector('#MegaMenuModels-FocusImage');
      this.focusContent = this.wrapper.querySelector('#MegaMenuModels-FocusContent');

      this.init();
    }

    init() {
      // Hover on models list
      this.modelTriggers.forEach(trigger => {
        trigger.addEventListener('pointerenter', (e) => this.handleModelHover(e.currentTarget));
        // Fallback for keyboard
        trigger.addEventListener('focus', (e) => this.handleModelHover(e.currentTarget));
      });
    }

    handleModelHover(triggerElement) {
      // Update active class
      this.modelTriggers.forEach(el => el.classList.remove('is-active'));
      triggerElement.classList.add('is-active');

      const parentLi = triggerElement.closest('li');
      if (!parentLi) return;

      const title = parentLi.dataset.modelTitle;
      const desc = parentLi.dataset.modelDesc;
      const url = parentLi.dataset.modelUrl;
      const imageUrl = parentLi.dataset.modelImage;

      this.updateFocusPanel(title, desc, url, imageUrl);
    }

    updateFocusPanel(title, desc, url, imageUrl) {
      this.focusContent.classList.add('is-transitioning');
      
      // Small timeout to allow transition to start
      setTimeout(() => {
        if (this.focusTitle) this.focusTitle.textContent = title;
        if (this.focusDesc) this.focusDesc.textContent = desc;
        if (this.focusUrl) this.focusUrl.href = url;
        
        if (this.focusImage && imageUrl) {
          this.focusImage.src = imageUrl;
          // Only remove transition class when image is loaded
          this.focusImage.onload = () => {
             this.focusContent.classList.remove('is-transitioning');
          };
        } else {
           this.focusContent.classList.remove('is-transitioning');
        }
      }, 150);
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    new MegaMenuModels();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["statement-reveal"] && !Shopify.designMode) return;
  try {
    
  class CurtisStatement extends HTMLElement {
    constructor() {
      super();
      this.phrases = this.querySelectorAll('.curtis-statement__phrase');
      this.punchline = this.querySelector('.curtis-statement__punchline');
      this.cta = this.querySelector('.curtis-statement__cta-wrapper');
      
      this.initAnimation();
    }

    initAnimation() {
      if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') {
        return;
      }

      const tl = window.gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: 'top 60%', 
          toggleActions: 'play none none none' 
        }
      });

      if (this.punchline) {
        tl.to(this.punchline, {
          autoAlpha: 1,
          y: 0,
          duration: 1.2,
          ease: "back.out(1.5)" 
        }, 0.2);
      }
      
      if (this.cta) {
        tl.to(this.cta, {
          autoAlpha: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out"
        }, 0.8);
      }

      if (this.phrases.length > 0) {
        this.phrases.forEach((phrase, index) => {
          window.gsap.set(phrase, { yPercent: 100, autoAlpha: 0 });
          
          const startTime = index * 2.5; 
          
          tl.to(phrase, {
            yPercent: -50, 
            autoAlpha: 1,
            duration: 0.8,
            ease: "power3.out"
          }, startTime);
          
          if (index < this.phrases.length - 1) {
            tl.to(phrase, {
              yPercent: -200, 
              autoAlpha: 0,
              duration: 0.6,
              ease: "power3.in"
            }, startTime + 1.8);
          }
        });
      }
    }

    disconnectedCallback() {
      if (window.ScrollTrigger) {
        window.ScrollTrigger.getAll().forEach(st => {
          if (st.trigger === this) st.kill();
        });
      }
    }
  }

  if (!customElements.get('statement-reveal')) {
    customElements.define('statement-reveal', CurtisStatement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workshop-build-contents"] && !Shopify.designMode) return;
  try {
    
  const initWorkshopProgress = (progress) => {
    const label = progress.querySelector('[data-workshop-progress-label]');
    const segments = Array.from(progress.querySelectorAll('[data-workshop-progress-segment]'));
    const targets = segments
      .map((segment) => {
        const target = document.querySelector(segment.dataset.progressTarget);
        return target ? { segment, target } : null;
      })
      .filter(Boolean);

    if (!label || targets.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      const visibleEntry = entries.find((entry) => entry.isIntersecting);
      if (!visibleEntry) return;

      const active = targets.find(({ target }) => target === visibleEntry.target);
      if (!active) return;

      const activeIndex = segments.indexOf(active.segment);

      segments.forEach((segment, index) => {
        segment.classList.toggle('is-active', segment === active.segment);
        segment.classList.toggle('is-complete', index <= activeIndex);
      });

      label.textContent = `${active.segment.dataset.progressNumber} / ${targets.length} - ${active.segment.dataset.progressLabel}`;
    }, {
      root: null,
      rootMargin: '-35% 0px -55% 0px',
      threshold: 0
    });

    targets.forEach(({ target }) => observer.observe(target));
  };

  document.querySelectorAll('[data-workshop-progress]').forEach(initWorkshopProgress);

  document.addEventListener('shopify:section:load', (event) => {
    event.target
      .querySelectorAll('[data-workshop-progress]')
      .forEach(initWorkshopProgress);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workshop-how-its-made"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn("GSAP/ScrollTrigger not loaded for Workshop component.");
      // Fallback
      document.querySelectorAll('.workshop .gsap-fade-up').forEach(el => {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    function initWorkshop() {
      // 1. Hero Content Initial Fade In
      const heroContent = document.querySelector('.js-workshop-hero-content');
      if (heroContent) {
        gsap.fromTo(heroContent, 
          { opacity: 0, y: 40 },
          { opacity: 1, y: 0, duration: 1.2, ease: "power3.out" }
        );
      }

      // 2. Pillars Grid Stagger
      const pillarsGrid = document.querySelector('#workshop-pillars-' + document.querySelector('.workshop').dataset.sectionId);
      const pillars = document.querySelectorAll('.js-workshop-pillar');
      
      if (pillars.length > 0 && pillarsGrid) {
        gsap.to(pillars, {
          scrollTrigger: {
            trigger: pillarsGrid,
            start: "top 85%"
          },
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: "power2.out"
        });
      }

      // 3. Process Header Fade Up
      const processHeader = document.querySelector('.js-workshop-process-header');
      if (processHeader) {
        gsap.to(processHeader, {
          scrollTrigger: {
            trigger: processHeader,
            start: "top 85%"
          },
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out"
        });
      }

      // 4. Timeline Steps Stagger
      const processSection = document.querySelector('.workshop__timeline');
      const steps = document.querySelectorAll('.js-workshop-step');
      
      if (steps.length > 0 && processSection) {
        gsap.to(steps, {
          scrollTrigger: {
            trigger: processSection,
            start: "top 80%"
          },
          opacity: 1,
          x: 0, 
          y: 0, // Fallback from base translateY
          duration: 0.8,
          stagger: 0.2, // Slightly slower stagger for vertical list
          ease: "back.out(1.2)" // Bumpy mechanical pop
        });
      }
    }

    document.addEventListener("shopify:section:load", (e) => {
      // Refresh triggers and re-init on theme editor save
      ScrollTrigger.refresh();
      initWorkshop();
    });

    // Slight delay to ensure layout is settled
    setTimeout(initWorkshop, 100);
  });

  } catch(e) { console.error(e); }
})();
})();
